import React, { useContext } from 'react';
import { QUESTIONNAIRE_REQUEST_CATEGORY } from 'common/constants/process-management';
import InformationDashboard409AContext from 'context/InformationDashboard409AContext/InformationDashboard409AContext';
import CurrentRequestedQuestionsList from './CurrentRequestedQuestionsList';
import { CurrentRequestedDocumentsAndQuestionsProps, QuestionProgress } from './types';

const CurrentRequestedQuestions = ({ currentInformationRequests }: CurrentRequestedDocumentsAndQuestionsProps) => {
  const { permissions } = useContext(InformationDashboard409AContext);
  const questions = currentInformationRequests.find(request =>request.category === QUESTIONNAIRE_REQUEST_CATEGORY);
  if (!questions?.id) {
    return null;
  }
  const filteredQuestions = {
    ...questions,
    responsible_users:
      questions?.responsible_users.map(user => ({
        id: user.id,
        email: user.email,
        full_name: user.full_name,
      })) || [],
    progress:
      questions?.progress.filter(
        (item): item is QuestionProgress =>
          'children_questions' in item
          && 'question_type' in item
          && 'options' in item
          && 'answers' in item
          && 'parent_question' in item
      ) || [],
  };

  const questionsToShow = {
    ...filteredQuestions,
    progress: permissions?.canUseInfoRequestLedger
      ? filteredQuestions.progress
      : filteredQuestions.progress.filter(question => question.answers.length > 0)
  };

  return <CurrentRequestedQuestionsList questions={questionsToShow} />;
};

export default CurrentRequestedQuestions;
